import React, { PureComponent } from 'react';
import qs from 'qs';
import { locationShape } from 'shapes';
import { func, number } from 'prop-types';
import PaginationItem from './PaginationItem/PaginationItem';

class Pagination extends PureComponent {
    static propTypes = {
        onPageChange: func.isRequired,
        nbPages: number.isRequired, // eslint-disable-line react/no-unused-prop-types
        currentPage: number.isRequired, // eslint-disable-line react/no-unused-prop-types
        location: locationShape.isRequired,
    };

    static getPagesToDisplay = (currentPage, nbPages) => {
        const { PROXIMITY } = Pagination;
        const nbPagesDisplayed = PROXIMITY * 2 + 1; // total number of pages displayed

        let begin = currentPage - PROXIMITY >= 1 ? currentPage - PROXIMITY : 1;
        const end =
            begin + nbPagesDisplayed <= nbPages
                ? begin + nbPagesDisplayed
                : nbPages + 1;
        const missingPageNb = nbPagesDisplayed - (end - begin);

        if (missingPageNb !== 0) {
            begin = missingPageNb < begin ? begin - missingPageNb : 1;
        }

        return [...Array(end - begin)].map((val, index) => begin + index);
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.currentPage !== state.currentPage ||
            props.nbPages !== state.nbPages
        ) {
            return {
                pagesToDisplay: Pagination.getPagesToDisplay(
                    props.currentPage,
                    props.nbPages,
                ),
                currentPage:
                    props.currentPage <= props.nbPages
                        ? props.currentPage
                        : props.nbPages,
                nbPages: props.nbPages,
            };
        }
        return null;
    }

    state = {
        pagesToDisplay: [],
        nbPages: 0,
        currentPage: 0,
    };

    getUrl = targetPage => {
        const { pathname, search } = this.props.location;

        if (!search) {
            return `${pathname}?page=${targetPage}`;
        }

        const parsedSearch = qs.parse(search, {
            plainObjects: true,
            ignoreQueryPrefix: true,
        });
        parsedSearch.page = targetPage;
        if (targetPage === 1) delete parsedSearch.page;

        return `${pathname}?${qs.stringify(parsedSearch)}`;
    };

    getRel = (currentPage, targetPage) => {
        if (currentPage - 1 === targetPage) return 'prev';
        if (currentPage + 1 === targetPage) return 'next';
        return null;
    };

    static PROXIMITY = 3; // proximity is the number of pages displayed on either side of the current page

    render() {
        const { onPageChange } = this.props;
        const { pagesToDisplay, nbPages, currentPage } = this.state;

        return (
            <ul className="pagination">
                {currentPage > 1 && (
                    <PaginationItem
                        target={currentPage - 1}
                        onClick={onPageChange}
                        label="‹"
                        className="pagination__item--prev"
                        dataQa="listingGoToPreviousPage"
                        rel="prev"
                        url={this.getUrl(currentPage - 1)}
                    />
                )}

                {pagesToDisplay.map(page => (
                    <PaginationItem
                        key={`pagination-page-${page}`}
                        label={`${page}`}
                        onClick={onPageChange}
                        target={page}
                        dataQa={`listingGoToPage${page}`}
                        active={currentPage === page}
                        url={this.getUrl(page)}
                        rel={this.getRel(currentPage, page)}
                    />
                ))}

                {currentPage < nbPages && (
                    <PaginationItem
                        target={currentPage + 1}
                        onClick={onPageChange}
                        label="›"
                        className="pagination__item--next"
                        dataQa="listingGoToNextPage"
                        rel="next"
                        url={this.getUrl(currentPage + 1)}
                    />
                )}
            </ul>
        );
    }
}

export default Pagination;
